import './Text.css';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const dict=

{

  "a":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/A.svg","A":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/A.svg",
  "b":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/B.svg","B":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/B.svg",
  "c":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/C.svg","C":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/C.svg",
  "d":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/D.svg","D":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/D.svg",
  "e":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/E.svg","E":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/E.svg",
  "f":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/F.svg","F":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/F.svg",
  "g":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/G.svg","G":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/G.svg",
  "h":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/H.svg","H":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/H.svg",
  "i":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/I.svg","I":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/I.svg",
  "j":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/J.svg","J":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/J.svg",
  "k":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/K.svg","K":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/K.svg",
  "l":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/L.svg","L":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/L.svg",
  "m":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/M.svg","M":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/M.svg",
  "n":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/N.svg","N":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/N.svg",
  "o":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/O.svg","O":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/O.svg",
  "p":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/P.svg","P":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/P.svg",
  "q":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/Q.svg","Q":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/Q.svg",
  "r":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/R.svg","R":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/R.svg",
  "s":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/S.svg","S":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/S.svg",
  "t":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/T.svg","T":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/T.svg",
  "u":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/U.svg","U":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/U.svg",
  "v":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/V.svg","V":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/V.svg",
  "w":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/W.svg","W":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/W.svg",
  "x":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/X.svg","X":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/X.svg",
  "y":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/Y.svg","Y":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/Y.svg",
  "z":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/Z.svg","Z":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/Z.svg",
  "0":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/0.svg","1":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/1.svg",
  "2":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/2.svg","3":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/3.svg",
  "4":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/4.svg","5":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/5.svg",
  "6":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/6.svg","7":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/7.svg",
  "8":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/8.svg","9":"https://signulation-t2s.s3.jp-tok.cloud-object-storage.appdomain.cloud/9.svg"
}


function Text() {
  const [input, setInput] = useState('');
  const [words, setWords] = useState([]);
  function onChangeInput(event) {
    // event.preventDefault();
    setInput(event.target.value);

  }
  function handleSubmit(event) {
    // event.preventDefault();
    let temp = [];
    temp = input.split(' ');
    setWords(temp);

  }

  return (
    <div style={{width: '100%'}} className="Text">
    <div className="old_container">
      <form>

      <h1> Enter Text</h1>
        <TextField className="inputfield" type="text" name="input" id="input" value={input} onChange={onChangeInput} size="small" label="Here..." variant="outlined" />
        &nbsp; &nbsp;&nbsp; &nbsp;
        <Button className="button_submit"  variant="contained" color="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </form>
    </div>

      <div className="container_text">
          {words.map((tile) => {
              let arr = tile.split('');
            return (
          <GridList className="gridList" cellHeight={100} cols={tile.length}>
            {
              arr.map((alphabet) =>(
                <GridListTile className="gridTile" cols={1}>
                  <img className="images" src={dict[alphabet]} alt="alt" height='100%' width='auto'/>
                </GridListTile>
                )
            )

            }
        </GridList>

                );
          }
          )}
      </div>

    </div>
  );
}


export default Text